import React from 'react';
import PropTypes from 'prop-types';
import AccessibleCarousel from '../AccessibleCarousel';
import { ImageOrderShape } from '../../utils/types';
import { gettext, interpolate } from '../../utils/text';

const GallerySlider = ({ images, initialSlide }) => {
    const galleryText = gettext('Gallery');

    const slides = images.map((image, index) => ({
        id: image.file.pk,
        content: (
            <div className="gallery-modal__media">
                <img
                    alt={interpolate(
                        gettext('Gallery item %(index)s'),
                        { index: index + 1 },
                        true,
                    )}
                    src={image.file.file}
                />
            </div>
        ),
        ariaLabel: interpolate(
            gettext('Gallery image %(current)s of %(total)s'),
            {
                current: index + 1,
                total: images.length,
            },
            true,
        ),
    }));

    return (
        <AccessibleCarousel
            slides={slides}
            ariaLabel={galleryText}
            initialIndex={initialSlide}
            variant="modal"
            className="gallery-modal__carousel"
        />
    );
};

GallerySlider.propTypes = {
    images: PropTypes.arrayOf(ImageOrderShape).isRequired,
    initialSlide: PropTypes.number.isRequired,
};

export default GallerySlider;
